export enum AttendanceClockStatus {
  CLOCKED_IN = "CLOCKED_IN",
  CLOCKED_OUT = "CLOCKED_OUT",
  NOT_CLOCKED_IN = "NOT_CLOCKED_IN",
}

export enum EmployeeAttendanceStatus {
  PRESENT = "PRESENT",
  LEAVE = "LEAVE",
  ABSENT = "ABSENT",
  HOLIDAY = "HOLIDAY",
}

export enum EmployeeAttendanceLocationType {
  OFFICE = "OFFICE",
  WORK_FROM_HOME = "WORK_FROM_HOME",
  REMOTE = "REMOTE",
  FIELD = "FIELD",
  OTHER = "OTHER",
}

export const EmployeeAttendanceStatusLabelMap: Record<
  EmployeeAttendanceStatus,
  string
> = {
  [EmployeeAttendanceStatus.PRESENT]: "Present",
  [EmployeeAttendanceStatus.LEAVE]: "On Leave",
  [EmployeeAttendanceStatus.ABSENT]: "Absent",
  [EmployeeAttendanceStatus.HOLIDAY]: "Holiday",
};

export const EmployeeAttendanceLocationTypeLabelMap: Record<
  EmployeeAttendanceLocationType,
  string
> = {
  [EmployeeAttendanceLocationType.OFFICE]: "Office",
  [EmployeeAttendanceLocationType.WORK_FROM_HOME]: "Work From Home",
  [EmployeeAttendanceLocationType.REMOTE]: "Remote",
  [EmployeeAttendanceLocationType.FIELD]: "Field",
  [EmployeeAttendanceLocationType.OTHER]: "Other",
};
